import { InjectionToken } from "@angular/core";
import { IAppConfig } from "../interface/app-config";
import { MainModule } from "../../section/main/main.module";
export const APP_DI_CONFIG: IAppConfig = {
  URL_PATH: "https://test.theaurapower.com/",
  URL_LOCALPATH: "http://localhost:59939/",
  MODULE_PATH: "",
  GRANT_TYPE: "password"
};

export let APP_CONFIG = new InjectionToken("app.config");
export function getFlexLayoutModule() {
  return MainModule;
}



// WEBPACK FOOTER //
// ./src/app/shared/constant/app-constant.ts